







import {Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class UserSelectSearch extends Vue {

    @Prop({ default: "" }) value: string

    mounted() {
        (this.$refs["input"] as HTMLInputElement | undefined)?.focus()
    }

    get model() {
        return this.value;
    }

    set model(value: string) {
        this.$emit('input', value)
    }
}
